import React, {useEffect, useState, useRef} from 'react';
import {connect} from 'react-redux';
import OperationsAreasPage from './pages/OperationsAreasPage/OperationsAreasPage';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import {initBlock, resetBlock} from './OperationsAreasBlockSlice';

const OperationsAreas = (props) => {
var currentView = null;

 useExtendedEffect((runSideEffects) => {
    props.initBlock({ blockData: props.iContent });

    return () => {
      if (runSideEffects()) {
        props.resetBlock();
      }
    };
  }, []);

   switch (props.page) {
      case 'operationsAreasPage': currentView = <OperationsAreasPage context={props.context}/>; break;
    }

  return (
    <>{currentView}</>
  );
};

const mapStateToProps = (state) => {
  return {
    page: state.operationsAreasBlock.page,

  };
};

const mapDispatchToProps = {
initBlock, resetBlock
};

export default connect(mapStateToProps, mapDispatchToProps)(OperationsAreas);
